import React from 'react';
import './src/styles/global.css';
import { SearchProvider } from './src/contexts/SearchContext';

// Wrap the entire app with SearchProvider
export const wrapRootElement = ({ element }) => {
  return <SearchProvider>{element}</SearchProvider>;
};
